/** biome-ignore-all lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome */
const debugCookieExists = () => document.cookie.indexOf('debug=true') >= 0;

export const trace =
    import.meta.env.DEV || debugCookieExists() ? (...args: any) => console.log('[debug]', ...args) : () => {};
